import { Navigate, useParams } from 'react-router-dom';

export default function AgencyMessagingRedirectPage() {
  const { id } = useParams();
  if (id) {
    return <Navigate to={`/agency/messaging/inbox/${id}`} />;
  }
  return <Navigate to={'/agency/messaging/inbox'} />;
}
